export default __webpack_public_path__ + "static/media/trustpilot.e11f2cd8.png";